import React from "react";

import TaxiServiceCellContent from "../components/TransferFromTaxiServiceCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function transferFromTaxiService({
	width,
	language,
	onResize,
}: Column.Options) {
	return base(
		ColumnId.TransferFromTaxiService,
		(item) => <TaxiServiceCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default transferFromTaxiService;
